import React, { FunctionComponent, ReactNode } from 'react';
import { RegularText, Container } from 'react-design-components';
import { GridJustification, GridItemsAlignment } from '@material-ui/core';
import useLinkButton from './hooks/useLinkButton';

interface Props {
  children: ReactNode;
  justify?: GridJustification;
  alignItems?: GridItemsAlignment;
}

const LinkButton: FunctionComponent<Props> = ({ children, justify, alignItems }) => {
  const { classes } = useLinkButton();
  return (
    <Container justify={justify} alignItems={alignItems}>
      <RegularText className={classes.linkButton}>{children}</RegularText>
    </Container>
  );
};

LinkButton.defaultProps = {
  justify: 'center',
  alignItems: 'center',
};

export default LinkButton;
